<div class="container">
  <div class="success">
    <img src="assets/images/successful.png">
    <p>{{ 'PAYMENT.RESULT' | translate }}</p>
  </div>
</div>
